import {useMutation} from "@tanstack/react-query";

import {useInvalidate} from "@/src/modules/core/hooks";
import {errorHandler} from "@/src/modules/core/lib";
import {captureDomainSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {vehiclesService} from "../services";

export default function useUpdateVehicle() {
  const invalidateVehicles = useInvalidate("vehicles");

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: Parameters<typeof vehiclesService.updateVehicle>[1];
    }) => vehiclesService.updateVehicle(id, data),
    onSuccess: () => {
      invalidateVehicles();
    },
    onError: (error) => {
      captureDomainSubmitError(error, {feature: "vehicles", operation: "vehicle_update"});
      errorHandler(error);
    },
  });
}
